import React from 'react';
import { Link } from 'react-router-dom';
import { shopIcon,locationIcon, starIcon, usersIcon,contractIcon, timerIcon   } from '../../../utils/icons';
import { useNavigate } from 'react-router-dom';
import './appliedJobCard.css'
import useSignedImage from '../../../hooks/useSignedImage';

const AppliedJobCard = ({ data, type, onEdit }) => {
  const jobPost = data.jobPost || data;
  const applicationId = data.id;
  const navigate = useNavigate();

  const {
    id,
    position,
    schedule,
    contract,
    yearsOfExperience = 'N/A',
    vacancies,
    description,
    createdAt,
    restaurant = {},
    location,
  } = jobPost;

  const { format = '', name = 'N/A', restaurantId } = restaurant;
  const address = location?.address || 'N/A';

  const imagePath = restaurant.profileImageUrl;
  const { imageUrl: signedImageUrl } = useSignedImage(imagePath, '/default-restaurant.png');

  const handleDetail = () => {
    navigate(`/trabajos/${id}`); 
  };

  const handleApplication = () => {
    navigate(`/panel-empleado/postulaciones/${applicationId}`);
  };

  return (
    <div className="applied-job-card__container">
      <div className="applied-job-card__col-1">
        <img className="applied-job-card__company-logo" src={signedImageUrl} alt={name} />
        <div className="applied-job-card__info">
          <div className="applied-job-card__info-main">
            <p><strong>{position}</strong></p>
            <p id="applied-job-card__company-name"><strong>{name}</strong></p>
          </div>
          <div className="applied-job-card__info-footer-container">
            <div className="applied-job-card__icon-title-container">
              {shopIcon}
              <div className="applied-job-card__label-info-container">
                <p><strong>Establecimiento:</strong></p>
                <p>{format}</p>
              </div>
            </div>
            <div className="applied-job-card__icon-title-container">
              {locationIcon}
              <div className="applied-job-card__label-info-container">
                <p><strong>Ubicación:</strong></p>
                <p>{address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="applied-job-card__col-2">
        <div className="applied-job-card__icons-posts_container">
          <div className="applied-job-card__icon-title-container">
            {timerIcon}
            <div className="applied-job-card__label-info-container">
              <strong><p>Jornada:</p></strong>
              <p>{schedule}</p>
            </div>
          </div>
          <div className="applied-job-card__icon-title-container">
            {starIcon}
            <div className="applied-job-card__label-info-container">
              <strong><p>Experiencia:</p></strong>
              <p>{yearsOfExperience}</p>
            </div>
          </div>
          <div className="applied-job-card__icon-title-container">
            {contractIcon}
            <div className="applied-job-card__label-info-container">
              <strong><p>Contrato:</p></strong>
              <p>{contract}</p>
            </div>
          </div>
          <div className="applied-job-card__icon-title-container">
            {usersIcon}
            <div className="applied-job-card__label-info-container">
              <strong><p>Vacantes:</p></strong>
              <p>{vacancies}</p>
            </div>
          </div>
        </div>
        <div className="applied-job-card__description-buttons-container">
          <div className="applied-job-card__description-container">
            <div className="applied-job-card__description">
              {description}
            </div>
            <h5>Publicado el {new Date(createdAt).toLocaleDateString()}</h5>
          </div>
          <div className="applied-job-card__button-container">
            <button className="applied-job-card__button" onClick={handleDetail}>Detalle</button>
            {applicationId && (
              <button className="applied-job-card__button" onClick={handleApplication}>Postulación</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppliedJobCard;
